/**
 * CookieNotice — first-visit disclosure banner (F-118 / F-016).
 *
 * WaveScorePro uses localStorage for playback state and Emergent-managed
 * auth cookies. Ghana's Data Protection Act 843 (2012) does not require an
 * explicit consent banner for strictly-necessary storage, but transparent
 * disclosure is best practice and the audit flagged its absence.
 *
 * Renders once. Dismissal is persisted to localStorage.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { T } from "@/lib/theme";

const KEY = "wsp_cookie_notice_seen_v1";

export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch { /* private mode — respect and don't badger */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-notice" role="status" style={{
      position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 400,
      maxWidth: 620, margin: "0 auto",
      background: T.navy, color: "#E2E8F0",
      borderRadius: 12, padding: "14px 18px",
      boxShadow: "0 10px 40px rgba(10,22,40,0.24)",
      fontFamily: "'Inter',system-ui,sans-serif",
      display: "grid", gridTemplateColumns: "1fr auto", gap: 14,
      alignItems: "center",
    }}>
      <div style={{ fontSize: 13, lineHeight: 1.55 }}>
        We use strictly-necessary cookies and browser storage for auth &amp; playback.
        No third-party trackers. Read our{" "}
        <Link to="/privacy" style={{ color: T.green, textDecoration: "none",
          borderBottom: `1px solid ${T.green}55` }}>Privacy Policy</Link>.
      </div>
      <button data-testid="cookie-notice-dismiss" onClick={dismiss} style={{
        background: T.green, color: "#fff", border: "none",
        padding: "8px 14px", borderRadius: 8, cursor: "pointer",
        fontSize: 12, fontWeight: 700, fontFamily: "inherit",
        whiteSpace: "nowrap",
      }}>OK, got it</button>
    </div>
  );
}
